import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from '../../../core/services/v2/user.service';
import { WorkingHours } from '../../../core/model/v2/workinghours';
import { Observable, throwError } from 'rxjs';
import { HospitalAffiliation } from '../../../core/model/v2/hospitalAffiliation';
import { Healthsystemwithaddress } from '../../../core/model/v2/healthSystem/healthsystemwithaddress.model';
import { debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { fadeInContent, MatSnackBar } from '@angular/material';
import { PractitionerLocations } from '../../../core/model/v2/practitioner/practitioner-locations';
import { Address } from '../../../physician/models/address.model';
import { PractitionerLocation } from '../../../physician/profile/models/practitioner';
import { AddressRequest } from '../../../physician/models/address-request.model';
import { GlobalHealthSystem } from '../../../core/model/v2/healthSystem/global-health-system';
import { GlobalLocation } from '../../../core/model/v2/healthSystem/global-location';
import { LocationRequest } from '../../../physician/models/location-request.model';
import { Callbacks } from 'jquery';
import { PractitionerDeleteLocation } from '../../../core/model/v2/practitioner/practitioner-delete-location.model';
import { Symptom } from '../../../core/model/v2/practitioner/symptom';
import { CodeTable } from '../../../core/model/v2/code-table';
import { CommonService } from '../../../core/services/v2/common.service';
import { debug } from 'util';
import { ActivatedRoute, Router } from '@angular/router';
interface Days {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-practice-location',
  templateUrl: './practice-location.component.html',
  styleUrls: ['./practice-location.component.scss']
})
export class PracticeLocationComponent implements OnInit {
  editLocationvar: boolean = false;
  @Input() SymptomData: Practitioner = new Practitioner();
  @Output() RefreshLocation = new EventEmitter();
  editLocationForm: FormGroup;
  shortName: string = '';
  indexer: number;
  hideDaysDiv: boolean = false;
  practId: number;
  currentUserId: number;
  newHSystemId: number;
  filteredAffiliations: Observable<HospitalAffiliation[]>;
  selected = false;
  healthsystemDetails: GlobalHealthSystem;
  healthSystemIds: number[] = [];
  healthSystemIdsInput: GlobalHealthSystem[] = [];
  affilicationCtrl = new FormControl();
  practitionerLocations: PractitionerLocations = new PractitionerLocations();
  practitonerDeleteLocation: PractitionerDeleteLocation = new PractitionerDeleteLocation();
  oldHSystemId: number;
  userAction: string = "";
  currentHS: GlobalHealthSystem;
  SymptomDataUpdated: Practitioner = new Practitioner();
  statesCodes: CodeTable;
  days: Days[] = [
    { value: '0', viewValue: 'Monday' },
    { value: '1', viewValue: 'Tuesday' },
    { value: '2', viewValue: 'Wednesday' },
    { value: '3', viewValue: 'Thursday' },
    { value: '4', viewValue: 'Friday' },
    { value: '5', viewValue: 'Saturday' },
  ];
  newWorkingHours: WorkingHours[];
  workinghour: WorkingHours[];
  patientId: number;
  isPractitioner: boolean = true;
  constructor(private fb: FormBuilder,
    private _loaderService: WindowLoaderService,
    private _practiceService: PracticeService,
    private _userService: UserService,
    private _snackBar: MatSnackBar,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {

    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((val) => {
        return this._filterAffilications(val || "");
      })
    );
  }

  ngOnInit() {
    this.getParams();
    if (this.patientId > 0) {
      this.isPractitioner = false;
    }
    this.getSates();
    this.SymptomDataUpdated = this.SymptomData;
    this.userAction = "N";
    if (this.SymptomData != undefined && this.SymptomData != undefined && this.SymptomData.healthSystems != undefined) {
      this.healthSystemIds = this.SymptomData.healthSystems.map((x) => x.id);
      let self = this;
      self.healthSystemIdsInput = self.SymptomData.healthSystems;
    }
    this.newHSystemId = 0;
    this.getUserDetails();
    //this._userService.getUserDetails().subscribe(
    //  (userDetails) => {

    //    this.practId = userDetails.practitionerId; // ['practitionerId'];
    //    this.currentUserId = userDetails.id; //['id'];
    //  },
    //  (error) => {
    //    console.error(error);
    //  },
    //  () => {
    //    this._loaderService.hide();
    //  }
    //);


  }
  getParams() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.patientId = params["patientId"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
  shortNameMethod(pname) {
    let result = "";
    if (this.SymptomData != null || this.SymptomData != undefined) {
      this.shortName = pname;
      let x = this.shortName.split(" ");
      if (x != undefined && x.length > 0) {
        let first = x[0];
        first = first.slice(0, 1);
        result = first;
        if (x.length > 1) {
          let second = x[1];
          second = second.slice(0, 1);
          result = first + second;
        }
      }
    
      return result;
    }
  }

  ngOnChanges() {
    this.getSates();
    this.SymptomDataUpdated = this.SymptomData;
    
    this.getUserDetails();
    this.userAction = "N";
    this.SymptomData;
    if (this.SymptomData != null || this.SymptomData != undefined) {
      this.healthSystemIds = this.SymptomData.healthSystems.map((x) => x.id);
      let self = this;
      self.healthSystemIdsInput = self.SymptomData.healthSystems;
    }
    else {
      this.healthSystemIds = [];
      this.healthSystemIdsInput = [];

    }
    //this.shortNameMethod(i);
  }
  getUserDetails() {

    this._userService.getUserDetails().subscribe(
      (userDetails) => {

        this.practId = userDetails.practitionerId; // ['practitionerId'];
        this.currentUserId = userDetails.id; //['id'];
      },
      (error) => {
        console.error(error);
      },
      () => {
        this._loaderService.hide();
      }
    );
  }
  get workingHours() {
    return this.editLocationForm.get("workingHours") as FormArray;
  }
  setTime(i) {
    let workingHrsArr = this.getWorkingHoursDetails();
    workingHrsArr.removeAt(i);
  }
  addNewDay() {

    let workingHrsArr = this.editLocationForm.get('workingHours') as FormArray;
    let newWorkingHrsEntry = this.fb.group({
      day: '',
      timeFrom: '',
      timeTo: ''
    })
    workingHrsArr.push(newWorkingHrsEntry);



    // this.SymptomData.healthSystems[this.indexer].workingHours.push({ day: '', hours: [""] });
    // this.editLocation(this.indexer);
  }
  getWorkingHoursDetails(): FormArray {
    return this.editLocationForm.get('workingHours') as FormArray;
  }
  async OnLocationSubmit(editPForm: FormGroup) {
    this.SymptomData = this.SymptomDataUpdated;

    if (this.validateForm(this.indexer) != true) {
      return false;
    }

    if (this.editLocationForm != undefined) {
      if (this.affilicationCtrl.value == undefined || this.affilicationCtrl.value == "") {
        this._snackBar.open("Please select a location!", "Ok", {
          duration: 5000
        });
        return false;
      }
    }
    let i = this.indexer;
    //let LocationValue = this.editLocationForm.value.Locationformcontrol;
    //let AddressValue = this.editLocationForm.value.Addressformcontrol;
    let PhoneValue = this.editLocationForm.value.Phoneformcontrol;
    let FaxValue = this.editLocationForm.value.Faxformcontrol;

    if (this.oldHSystemId != undefined) {
      this.healthSystemIds.splice(i, 1);
    }
    if (this.userAction != "D") {
      let indx = this.healthSystemIds.indexOf(this.newHSystemId);
      if (indx == -1) {
        this.healthSystemIds.push(this.newHSystemId);
      }
    }
    else {
      this.healthSystemIds.splice(i, 1);
    }
    this.workinghour = this.editLocationForm.value.workingHours.map((wh) => {
      return {

        day: wh.day,
        hours: [wh.isClosed ? "" : wh.timeFrom + "-" + wh.timeTo],
      };
    });
    const physicianWH = {
      practitionerId: this.SymptomData.id,
      id: 0,
      userId: this.SymptomData.id,
      healthSystemId: this.newHSystemId > 0 ? this.newHSystemId : this.SymptomData.healthSystems[this.indexer].id,
      workingHours: this.workinghour,
    }
    this.practitionerLocations.userid = this.SymptomData.id;
    this.practitionerLocations.healthsystemid = this.newHSystemId;
    this.practitionerLocations.healthSystemIds = this.healthSystemIds;
    this.practitionerLocations.primaryPhoneNumber = PhoneValue;
    this.practitionerLocations.faxNumber = FaxValue;
    this.practitionerLocations.addressRequest = new LocationRequest();
    this.practitionerLocations.addressRequest.Id = this.SymptomData.healthSystems[this.indexer].location.id;
    this.practitionerLocations.addressRequest.Address1 = this.editLocationForm.value.Addressformcontrol1;
    this.practitionerLocations.addressRequest.Address2 = this.editLocationForm.value.Addressformcontrol2;
    this.practitionerLocations.addressRequest.City = this.editLocationForm.value.City;
    this.practitionerLocations.addressRequest.State = this.editLocationForm.value.state;
    this.practitionerLocations.addressRequest.ZipCode = this.editLocationForm.value.ZipCode;
    this.practitionerLocations.addressRequest.Country = this.editLocationForm.value.Country;
    this.practitionerLocations.practitionerWorkingHoursDto = physicianWH;
    this.practitionerLocations.uAction = this.userAction;
    if (this.healthsystemDetails != null && this.healthsystemDetails != undefined) {
      this.SymptomData.healthSystems.push(this.healthsystemDetails);
    }
    const self = this;
    self._loaderService.show();
    
    await self._practiceService.updatePractitionerLocation(self.practitionerLocations).subscribe(
      (res) => {
        
        if (self.healthsystemDetails != undefined && self.healthsystemDetails != null) {
          let hsid = self.getHSIndexNumber(self.SymptomData.healthSystems, self.healthsystemDetails.id);
          if (hsid != null && hsid != undefined) {
            self.SymptomData.healthSystems[hsid].workingHours = self.workinghour;
          }
          else {
            self.SymptomData.healthSystems[self.indexer].workingHours = self.workinghour;
          }
        }
        else {
          self.SymptomData.healthSystems[self.indexer].workingHours = self.workinghour;
        }
        //self.editLocation(self.indexer);
        self.oldHSystemId = undefined;
        console.log("Working hours were successfully updated");
        
        self.getPractitionerDetails(self.SymptomData.id);
        self.editLocationvar = false;
        self._loaderService.hide();

      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      }
    );

  }
  async getPractitionerDetails(pid) {
    await this._practiceService.getPractitionerDetails(pid).subscribe((sdata) => {
      this.SymptomData = sdata;
    })
  }
  editLocation(i) {
    
    this.userAction = "E";
    this.indexer = i;
    this.editLocationvar = true;
    this.affilicationCtrl.setValue(this.SymptomData ? this.SymptomData.healthSystems[i].name : "");
    this.oldHSystemId = this.SymptomData ? this.SymptomData.healthSystems[i].id : 0;
    this.newHSystemId = this.oldHSystemId;
    this.editLocationForm = this.fb.group(
      {
        Addressformcontrol: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.zipCode + ", " + this.SymptomData.healthSystems[i].location.address1 + ", " + this.SymptomData.healthSystems[i].location.address2 + ", " + this.SymptomData.healthSystems[i].location.state
            : null
        ),
        Addressformcontrol1: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.address1
            : null
        ),
        Addressformcontrol2: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.address2
            : null
        ),
        City: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.city
            : null
        ),
        state: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.state
            : null
        ),
        ZipCode: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.zipCode
            : null
        ),
        Country: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].location.country
            : null
        ),
        Phoneformcontrol: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].primaryPhoneNumber
            : null
        ),
        Faxformcontrol: new FormControl(
          this.SymptomData
            ? this.SymptomData.healthSystems[i].faxNumber
            : null
        ),
        workingHours: this.fb.array(
          this.SymptomData.healthSystems[i].workingHours
            ? this.SymptomData.healthSystems[i].workingHours.map((workings) => {
              return this.fb.group({
                day: workings.day,
                timeFrom:
                  workings.hours[0] != ""
                    ? workings.hours[0].split("-")[0].trim()
                    : "",
                timeTo:
                  workings.hours[0] != ""
                    ? workings.hours[0].split("-")[1].trim()
                    : "",
                isClosed: workings.hours[0] == "" ? false : false,
              });
            })
            : null
        ),
      });
  }

  _filterAffilications(value: string): Observable<any[]> {

    if (value.length >= 2) {
      this._loaderService.show();

      return this._practiceService.getHealthOrganizationDetailsByLoggedUser().pipe(
        map((a) =>
          a.healthSystems.filter((option) => {

            this._loaderService.hide();
            return option.name.startsWith(value); option.name.toLowerCase().indexOf(value.toLowerCase()) === 0;
          })
        )
      );

    }

  }

  optionClicked(event: Event, affiliation: HospitalAffiliation) {
    event.stopPropagation();
    const self = this;
    self.selected = true;
    self._practiceService.getHealthSystemByNPI(affiliation.npi).subscribe(
      (data) => {
        self.healthsystemDetails = data;
        
        self.currentHS = self.SymptomDataUpdated.healthSystems[self.indexer];
        self._loaderService.hide();
        let indexHS = self.getHSIndexNumber(self.SymptomDataUpdated.healthSystems, self.healthsystemDetails.id);
        if (indexHS != undefined && indexHS != null && indexHS > 0) {
          if (this.userAction == "E") {
            if (self.indexer != indexHS) {
              this.editLocation(self.indexer);
            }
          }
          else {
            self.affilicationCtrl.setValue("");
          }
          this._snackBar.open("Selected heathSystem already exists!", "Ok", {
            duration: 5000
          });
          self.healthsystemDetails = null;
          return false;
        }
        else {
          if (this.userAction == "E") {
            this.SymptomDataUpdated.healthSystems.splice(self.indexer, 1);
          }
        }
        if (self.healthsystemDetails.location == null) {
          self.editLocationForm.controls.Addressformcontrol.setValue("");
        }
        else {
          self.editLocationForm.controls.Addressformcontrol.setValue(self.healthsystemDetails.location.address1 == null ?
            "" : self.healthsystemDetails.location.address1 + " " + self.healthsystemDetails.location.address2 == null ?
              "" : self.healthsystemDetails.location.city + " " + self.healthsystemDetails.location.city == null ? "" :
                self.healthsystemDetails.location.city + " " + self.healthsystemDetails.location.zipCode == null ? "" :
                  self.healthsystemDetails.location.zipCode + " " + self.healthsystemDetails.location.state == null ? "" :
                    self.healthsystemDetails.location.state);

          self.editLocationForm.controls.Addressformcontrol1.setValue(self.healthsystemDetails.location.address1);
          self.editLocationForm.controls.Addressformcontrol2.setValue(self.healthsystemDetails.location.address2);
          self.editLocationForm.controls.City.setValue(self.healthsystemDetails.location.city);
          self.editLocationForm.controls.state.setValue(self.healthsystemDetails.location.state);
          self.editLocationForm.controls.ZipCode.setValue(self.healthsystemDetails.location.zipCode);
          self.editLocationForm.controls.Country.setValue(self.healthsystemDetails.location.country);
        }

        self.editLocationForm.controls.Phoneformcontrol.setValue(self.healthsystemDetails.primaryPhoneNumber == null ? "" : self.healthsystemDetails.primaryPhoneNumber);
        self.editLocationForm.controls.Faxformcontrol.setValue(self.healthsystemDetails.faxNumber == null ? "" : self.healthsystemDetails.faxNumber);
        self.newHSystemId = self.healthsystemDetails.id;
        //self.SymptomDataUpdated.healthSystems.push(self.healthsystemDetails);
        indexHS = self.getHSIndexNumber(self.SymptomDataUpdated.healthSystems, self.newHSystemId);
        self.indexer = indexHS;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  backToLocation() {

    if (this.currentHS != undefined) {
      let indexHS = this.getHSIndexNumber(this.SymptomData.healthSystems, this.newHSystemId);
      this.SymptomData.healthSystems.splice(indexHS, 1);
      this.SymptomData.healthSystems.push(this.currentHS);
    }
    this.editLocationvar = false;
  }
  addNewLocation() {
    this.affilicationCtrl.setValue("");
    this.editLocationForm = this.fb.group(
      {
        Addressformcontrol: new FormControl(""),
        Phoneformcontrol: new FormControl(""),
        Faxformcontrol: new FormControl(""),
        Addressformcontrol1: new FormControl(""),
        Addressformcontrol2: new FormControl(""),
        City: new FormControl(""),
        state: new FormControl(""),
        ZipCode: new FormControl(""),
        Country: new FormControl(""),

        workingHours: new FormArray([
          this.fb.group({
            day: new FormControl(''),
            timeFrom: new FormControl(''),
            timeTo: new FormControl('')
          })
        ])
      });
    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((val) => {
        return this._filterAffilications(val || "");
      })
    );
    this.editLocationvar = true;
    this.userAction = "N";
  }
  async deleteLocation(i) {
    this.oldHSystemId = i;
    this.userAction = "D";

    //this.OnLocationSubmit(this.editLocationForm);
    this.SymptomData.healthSystems.splice(i, 1);
    let hsids = this.SymptomData.healthSystems.map((x) => x.id);

    this.practitonerDeleteLocation.healthSystemIds = hsids;
    this.practitonerDeleteLocation.PractitionerId = this.SymptomData.id;
    this._loaderService.show();
    await this._practiceService.deletePractitionerLocation(this.practitonerDeleteLocation).subscribe(
      (res) => {
        this.RefreshLocation.emit;
        this.editLocationvar = false;
        this.oldHSystemId = undefined;
        this._loaderService.hide();
        if (res) {

          console.log("Health Location successfully deleted");


        } else {
          console.error(res);
          this.editLocationvar = false;
          this._loaderService.hide();
        }
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      }

    );

  }
  getHSIndexNumber(globalHS: GlobalHealthSystem[], selectedHSid: number) {
    let indexHS = 0
    let hSObj = globalHS.find((x) => x.id == selectedHSid);
    if (hSObj != undefined && hSObj != null) {
      indexHS = globalHS.indexOf(hSObj, 0);
    }
    return indexHS;
  }
  validateForm(i) {

    let isSuccess: boolean = true;
    let workingHrsArr = this.editLocationForm.get('workingHours') as FormArray;
    if (this.affilicationCtrl.value == undefined || this.affilicationCtrl.value == "") {
      this._snackBar.open("Please select a location!", "Ok", {
        duration: 5000
      });
      isSuccess = false;
    }

    workingHrsArr.controls.forEach((x) => {
      if (x.value.day == "") {
        this._snackBar.open("Day cannot be blank!", "Ok", {
          duration: 5000
        });
        isSuccess = false;
      }
      else if (this.checkDays(0, x.value.day) != true) {
        isSuccess = false;
      }
      else if (x.value.timeFrom == "") {
        this._snackBar.open("Start time cannot be blank!", "Ok", {
          duration: 5000
        });
        isSuccess = false;
      }
      else if (x.value.timeTo == "") {
        this._snackBar.open("End time cannot be blank!", "Ok", {
          duration: 5000
        });
        isSuccess = false;
      }
      else if (x.value.timeFrom != undefined && x.value.timeFrom != undefined) {
        let res = Date.parse('01/01/2011 ' + x.value.timeFrom) < Date.parse('01/01/2011 ' + x.value.timeTo);
        if (res == false) {
          this._snackBar.open("End time cannot be less then start time!", "Ok", {
            duration: 5000
          });
          isSuccess = false;
        }

      }
    });
    return isSuccess;
  }
  validateTime(i) {

    let workingHrsArr = this.editLocationForm.get('workingHours') as FormArray;
    let timeFrom = workingHrsArr.controls[i].value.timeFrom;
    let timeTo = workingHrsArr.controls[i].value.timeTo;
    if (timeFrom == undefined || timeFrom == "") {
      this._snackBar.open("Please enter from time!", "Ok", {
        duration: 5000
      });
    } else if (timeTo == undefined || timeTo == "") {
      this._snackBar.open("Please enter end time!", "Ok", {
        duration: 5000
      });
    }
    if (timeFrom != undefined && timeTo != undefined) {
      let res = Date.parse('01/01/2011 ' + timeFrom) > Date.parse('01/01/2011 ' + timeTo)
        > true
    }

  }
  checkDays(i, dayName?: string) {

    let count: number = 0;
    let workingHrsArr = this.editLocationForm.get('workingHours') as FormArray;

    workingHrsArr.controls.filter((x) => x.value.day == (dayName != undefined ? dayName : workingHrsArr.controls[i].value.day)).forEach(element => {
      count++;
    });

    if (count > 1) {
      this._snackBar.open("Duplicate day selected!", "Ok", {
        duration: 5000
      });
      // workingHrsArr.controls.splice(i, 1);
      return false;
    }
    else {
      return true;
    }
  }
  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }

  redirectToPractice(element) {
    this.router.navigate(["/practice/profile/profilelocation/" + element.id.toString()]);
  }

}
